import { defineComponent as t, openBlock as r, createElementBlock as o, mergeProps as s, renderSlot as a } from "vue";
import "./ghl-ui.es228.js";
const l = t({
  name: "UITextSmRegular",
  inheritAttrs: !1
}), n = t({
  ...l,
  setup(m) {
    return (e, c) => (r(), o("div", s(e.$attrs, { class: "hl-text-sm-regular" }), [
      a(e.$slots, "default")
    ], 16));
  }
}), _ = n;
export {
  _ as default
};
